// ChatRouteSync.tsx
import { useParams } from 'react-router-dom';
import { useChat } from '../../context/chatContext';
import { useEffect } from 'react';
import Main from '../layout/main';
import ChatView from './chatView';
import Sidebar from '../layout/sidebar';
import PermanentChat from './PermanentChat';

const ChatRouteSync: React.FC<{ mobileOpen: boolean; onDrawerToggle: () => void }> = ({ mobileOpen, onDrawerToggle }) => {
  const { chatId } = useParams<{ chatId: string }>();
  const { setActiveChatId, activeChatId, chatSocketId } = useChat();

  useEffect(() => {
    // Route drives state: only update when different
    if (chatId && chatId !== activeChatId) {
      setActiveChatId(chatId);
    }
    // If route has no chatId, do nothing here.
  }, [chatId, activeChatId, setActiveChatId]); // << add activeChatId

  if(chatId == chatSocketId) {
      return (
    <>
      <Sidebar mobileOpen={mobileOpen} onDrawerToggle={onDrawerToggle} />
      <Main>
        <PermanentChat />
      </Main>
    </>
  );
  }

  return (
    <>
      <Sidebar mobileOpen={mobileOpen} onDrawerToggle={onDrawerToggle} />
      <Main>
        <ChatView />
      </Main>
    </>
  );
};

export default ChatRouteSync;
